module.exports = __webpack_public_path__ + "img/PCxiazai.b04e6587.png";